<template>
  <div class="upcoming-events-tabs-margin">
    <v-btn-toggle
      class="upcoming-events"
      :class="{ 'button-text-style': buttonTextStyle }"
      v-model="selectedDay"
      mandatory
    >
      <v-btn
        v-for="day in defaultDays"
        :value="day.format('YYYY-MM-DD')"
        :key="day.format('YYYY-MM-DD')"
      >
        <span>{{ applyDateFormat(day) }}</span>

        <v-avatar
          v-if="Object.keys(amountByDate).length"
          size="24"
        >
          {{ amountByDate[day.format('YYYY-MM-DD')] || 0 }}
        </v-avatar>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import moment from 'moment'
import { displayFormatDate } from '@/lib/helpers/DateUtils'

export default {
  name: 'DateButtons',

  props: {
    numberOfDaysToDisplay:{
      type: Number,
      default: 5,
    },

    buttonTextStyle: {
      type: Boolean,
      default: false,
    },

    days: {
      type: Array,
      default () {
        return null
      },
    },

    amountByDate: {
      type: Object,
      default () {
        return {}
      },
    },
  },

  data () {
    return {
      moment,
      displayFormatDate,
      selectedDay: null,
    }
  },

  computed: {
    defaultDays () {
      if (this.days) {
        return this.days
      }

      const days = []
      for (let i = 0; i < this.numberOfDaysToDisplay; i++) {
        days.push(moment().add(i, 'd'))
      }
      return days
    },
  },

  watch: {
    selectedDay (value) {
      this.$emit('change', value)
    },
  },

  methods: {
    applyDateFormat (day) {
      if (this.moment().isSameOrAfter(day)) {
        return this.$t('upcoming_events.today')
      }

      return displayFormatDate(day, 'sm', true)
    },
  },
}
</script>

<style lang="scss">
.theme--light.v-btn-toggle.upcoming-events:not(.button-text-style) > .v-btn:not(.v-item--active) {
  color: var(--v-grey-2-base) !important;
  border: 2px solid var(--v-grey-2-base) !important;
  background: #FFF;
}

.theme--light.v-btn-toggle.upcoming-events.button-text-style > .v-btn:not(.v-item--active) {
  color: var(--v-grey-2-base) !important;
  background: #FFF;
  border-style: none;
}

.theme--light.v-btn-toggle.upcoming-events.button-text-style > .v-btn {
  margin-right: 7px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn:not(.v-item--active) {
  border-color: var(--v-grey-2-base) !important;
}

.v-btn-toggle.upcoming-events.button-text-style > .v-btn.v-btn--active {
  &.v-btn--active {
    color: var(--v-primary-lighten1) !important;
    background-color: #FFF !important;
    border-style: none;
  }
}
.upcoming-events {
  .v-btn .v-avatar {
    color: var(--v-grey-2-base) !important;
    background: var(--v-grey-3-base) !important;
    margin-left: 7px;
  }
  .v-btn.v-btn--active .v-avatar {
    color: #FFF !important;
    background: var(--v-primary-darken1) !important;
  }
}

.v-btn-toggle.upcoming-events {
  max-width: calc(100%);
  overflow: auto;

  >.v-btn {
    background: none !important;
    text-transform: none !important;
    font-family: 'Urbanist';
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px; /* 142.857% */
    letter-spacing: 0.25px;
    padding: 8px 15px !important;
    border-left-width: thin !important;
    max-height: 36px;

    &:before, .v-ripple__container {
      display: none !important;
    }

    &.v-btn--active {
      color: white;
      background-color: var(--v-primary-lighten1) !important;
      border-color: var(--v-primary-lighten1) !important;
    }

    &:not(:last-child) {
      margin-right: 16px;
    }
  }
}
.app-section-width {
  .upcoming-events-tabs-margin {
    width: min(100vw, 600px) !important;
  }
}
.upcoming-events-tabs-margin {
  margin-bottom: 14px;
  width: 100vw;
  margin-left: -28px;
  margin-right: -28px;

  .v-item-group {
    .v-btn:is(:first-of-type) {
      margin-left: 28px;
    }

    .v-btn:is(:last-of-type) {
      margin-right: 28px;
    }
  }
}
</style>
